import React, { useState } from "react";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import SoftInput from "StyleFeatures/SoftInput";
import SoftButton from "StyleFeatures/SoftButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CoverLayout from "Common/CoverLayout";

// Images
import curved9 from "assets/images/curved-images/curved-6.jpg";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

function EmployeeSignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);

  const navigate = useNavigate();

  const location = useLocation();
  const redirectTo = location.state?.from || "/applicantPortal";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError(null);
    setPasswordError(null);

    // Validate input fields
    let valid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      setEmailError("Email is required");
      valid = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      valid = false;
    }
    if (!password) {
      setPasswordError("Password is required");
      valid = false;
    }

    if (!valid) return;

    try {
      setIsLoading(true);

      // Make POST request to login endpoint
      const response = await axiosInstance.post(API.candidate.login, {
        email,
        password,
      });

      //  API now returns applicant object directly
      if (response?.data) {
        const userData = response.data;

        // backend sends jobApplicantId, not employeeId
        const applicantId = userData.jobApplicantId;
        const userEmail = userData.email;

        // save to localStorage
        localStorage.setItem("userId", applicantId);
        sessionStorage.setItem("candidateId", userData.id);
        localStorage.setItem("userEmail", userEmail);

        // Navigate after login

        navigate(redirectTo, { replace: true });
      } else {
        console.error("Unexpected response format:", response);
        setError("Unexpected response format");
      }
    } catch (error) {
      console.error("Login failed:", error.response ? error.response.data : error.message);

      const backendError = error.response?.data;
      const errorMessage =
        backendError?.details || backendError?.message || "Invalid email or password!";

      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <CoverLayout
        title="Applicant Login"
        description="Enter your email and password to sign in"
        image={curved9}
      >
        <SoftBox component="form" role="form" onSubmit={handleSubmit}>
          <ToastContainer position="top-left" />
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Email
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError(null);
              }}
              className={`form-control ${emailError ? "is-invalid" : ""}`}
            />
            {emailError && (
              <SoftTypography color="error" variant="caption">
                {emailError}
              </SoftTypography>
            )}
          </SoftBox>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Password
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError(null);
              }}
              className={`form-control ${passwordError ? "is-invalid" : ""}`}
            />
            {passwordError && (
              <SoftTypography color="error" variant="caption">
                {passwordError}
              </SoftTypography>
            )}
          </SoftBox>

          {error && (
            <SoftBox mb={2}>
              <SoftTypography color="error" variant="body2">
                {error}
              </SoftTypography>
            </SoftBox>
          )}

            <SoftBox textAlign="right" mb={2}>
            <SoftTypography
              variant="caption"
              color="info"
              fontWeight="medium"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/candidate-forgot-password")}
            >
              Forgot Password?
            </SoftTypography>
          </SoftBox>
          
          <SoftBox mt={4} mb={1}>
            <SoftButton type="submit" variant="gradient" color="info" fullWidth>
              {isLoading ? "Please Wait..." : "Login"}
              {isLoading && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
            </SoftButton>
          </SoftBox>
          <SoftBox mt={2} textAlign="center">
            <SoftTypography variant="caption">
              Don’t have an account?{" "}
              <span
                style={{ color: "#17c1e8", cursor: "pointer", fontWeight: "bold" }}
                onClick={() => navigate("/empRegister")}
              >
                Register
              </span>
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </CoverLayout>
    </>
  );
}

export default EmployeeSignIn;
